var _g, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSmallSoundOn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_984_11640)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.25 3.38333C11.25 2.27 9.90334 1.7125 9.11667 2.5L5.36667 6.25H3.75667C2.80584 6.25 1.82501 6.80333 1.54001 7.8375C1.34665 8.54204 1.24911 9.26941 1.25001 10C1.25001 10.7483 1.35084 11.4733 1.54167 12.1625C1.82584 13.1958 2.80667 13.75 3.75751 13.75H5.36584L9.11584 17.5C9.90334 18.2875 11.25 17.73 11.25 16.6167V3.38333ZM15.4867 4.255C15.6039 4.13796 15.7627 4.07222 15.9283 4.07222C16.094 4.07222 16.2528 4.13796 16.37 4.255C19.5433 7.4275 19.5433 12.5717 16.37 15.745C16.3128 15.8064 16.2438 15.8557 16.1671 15.8898C16.0905 15.924 16.0077 15.9423 15.9238 15.9438C15.8399 15.9453 15.7565 15.9299 15.6787 15.8984C15.6009 15.867 15.5302 15.8202 15.4708 15.7609C15.4115 15.7015 15.3647 15.6308 15.3332 15.553C15.3018 15.4752 15.2864 15.3918 15.2878 15.3079C15.2893 15.224 15.3077 15.1412 15.3419 15.0646C15.376 14.9879 15.4253 14.9189 15.4867 14.8617C16.1252 14.2233 16.6317 13.4653 16.9772 12.6312C17.3228 11.797 17.5006 10.9029 17.5006 10C17.5006 9.09709 17.3228 8.20302 16.9772 7.36885C16.6317 6.53468 16.1252 5.77675 15.4867 5.13833C15.3696 5.02115 15.3039 4.86229 15.3039 4.69667C15.3039 4.53104 15.3696 4.37219 15.4867 4.255Z",
    fill: "#FEFEFE"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_984_11640)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.2757 6.46416C13.3337 6.40608 13.4027 6.36001 13.4785 6.32857C13.5544 6.29714 13.6357 6.28096 13.7178 6.28096C13.7999 6.28096 13.8812 6.29714 13.9571 6.32857C14.0329 6.36001 14.1018 6.40608 14.1599 6.46416C14.6242 6.92846 14.9926 7.4797 15.2439 8.08638C15.4953 8.69306 15.6246 9.34331 15.6246 9.99999C15.6246 10.6567 15.4953 11.3069 15.2439 11.9136C14.9926 12.5203 14.6242 13.0715 14.1599 13.5358C14.0419 13.6496 13.884 13.7125 13.7202 13.711C13.5563 13.7095 13.3996 13.6437 13.2837 13.5278C13.1679 13.4119 13.1022 13.2551 13.1009 13.0912C13.0996 12.9273 13.1626 12.7695 13.2765 12.6517C13.6248 12.3034 13.901 11.89 14.0894 11.4351C14.2779 10.9801 14.3749 10.4925 14.3749 9.99999C14.3749 9.50753 14.2779 9.01989 14.0894 8.56492C13.901 8.10995 13.6248 7.69655 13.2765 7.34833C13.1595 7.23114 13.0938 7.07229 13.0938 6.90666C13.0938 6.74103 13.1595 6.58218 13.2765 6.46499L13.2757 6.46416Z",
    fill: "#FEFEFE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_984_11640",
    x: 0.25,
    y: 1.13129,
    width: 19.5,
    height: 17.7374,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.24 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_984_11640"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_984_11640",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_984_11640",
    x: 12.0938,
    y: 5.28096,
    width: 4.53125,
    height: 9.43011,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.24 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_984_11640"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_984_11640",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallSoundOn);
export default __webpack_public_path__ + "static/media/SmallSoundOn.de61e5bd6e65665b2e3522d774fbfb4b.svg";
export { ForwardRef as ReactComponent };